(function(intro, $, undefined)
{
    var sections,
        choices;

    intro.init = function()
    {
        this.cacheInitialized = [];
        this.sections = {
            'village' : 'uiVillage',
            'villages' : 'uiVillages',
            'difficulty' : 'uiDifficulty',
            'summary' : 'uiSummary'
        };

        // default choices
        this.choices = {
            'difficulty' : 1,
            'village' : 'hidden-sand',
            'ninja' : 'gaara-genin'
        };

        if (typeof jsData['choices'] !== 'undefined')
            this.choices = jsData['choices'];

        main.loadPageEvents(jsData['subPage']);

        this.uiEvents();

        main.setStartingPushState();
    };

    intro.uiEvents = function()
    {
        main.$_centercol.on('click', '.js-goto-intro', loadIntroPage);
        main.$_centercol.on('click', '#difficulty-list .c-button', clickDifficultyButton);
        main.$_centercol.on('click', '#village-list .c-button', clickVillageButton);
        main.$_centercol.on('click', '#ninja-list .c-button', clickNinjaButton);
        main.$_centercol.on('click', '#summary-button', clickSummaryButton);
	    main.$_centercol.on('click', '#teacher-list .c-card', clickSelectedTeacher);
	    main.$_centercol.on('mouseover', '.js-stat-stats', main.showTooltipAttributes);


        function clickSelectedTeacher()
        {
	        var $_this = $(this);

	        $_this.addClass('-c-sel').siblings().removeClass('-c-sel');

	        // set selected teacher for post data
	        intro.choices['teacher'] = $_this.attr('data-ninja');

	        // update selected card data
	        var $_currentTeacher = $('#ninja-teacher');
	        var $_cloneCard = $_this.clone().removeClass('-c-sel');

	        $_currentTeacher.find('.c-card').replaceWith($_cloneCard);
	        $_currentTeacher.find('.js-ninja-teacher em').html($_this.attr('data-name'));
        }

        function clickSummaryButton()
        {
            var linkData = {
                url: '/intro/complete',
                subpage: 'complete',
                data: { choices: intro.choices },
                type: 'POST'
            };

            main.loadPage(linkData);

            return false;
        }

        function clickNinjaButton()
        {
            var $_this = $(this);

            if (!$_this.hasClass('-color-yes'))
                return false;

            intro.choices.ninja = $_this.data('ninja');

            var linkData = {
                url: '/intro/summary',
                subpage: 'summary',
                data: { choices: intro.choices },
                type: 'POST'
            };

            main.loadPage(linkData);

            return false;
        }

        function clickVillageButton()
        {
            var $_this = $(this),
                village = $_this.data('village');

	        if (!$_this.hasClass('-color-yes'))
		        return false;

            intro.choices.village = village;

            var linkData = {
                url: '/intro/village/' + village,
                subpage: 'village'
            };

            main.loadPage(linkData);

            return false;
        }

        function clickDifficultyButton()
        {
            var $_this = $(this),
                difficulty = $_this.data('difficulty');

	        if (!$_this.hasClass('-color-yes'))
		        return false;

            intro.choices.difficulty = difficulty;

            var linkData = {
                url: '/intro/village',
                subpage: 'villages',
                data: { difficulty: difficulty },
	            type: 'POST'
            };

            main.loadPage(linkData);

            return false;
        }

        function loadIntroPage(event)
        {
            event.stopImmediatePropagation();

            var $this = $(this),
                url = $this.attr('data-url'),
                subpage = $this.attr('data-subpage') || url.substr(url.lastIndexOf('/') + 1);

            var linkData = {
                url: url,
                subpage: subpage
            };

            main.loadPage(linkData);

            return false;
        }
    };

    intro.uiSummary = function()
    {
        main.displayNinjaGraphs($('.c-ninja-graph canvas'));


        // unset any potential selected teachers
	    delete intro.choices['teacher'];
    };

    intro.uiVillage = function()
    {
        main.displayNinjaGraphs($('.c-ninja-graph canvas'));
    };

    intro.uiVillages = function()
    {

    };

    intro.uiDifficulty = function()
    {

    };

}(window.intro = window.intro || {}, jQuery));

$(function()
{
    intro.init();
});
